<template>
    <div class="container">
        <div class="circle">
            <svg :width="diameter" :height="diameter">
                <path
					class="path"
                    v-for="(color, index) in colors"
                    :v-model="selectedIndex"
                    :key="index"
                    :d="pie(index)"
                    :fill="color"
                    :opacity="opacities[index]"
                    stroke="none"
					v-on:click="handleClick(index)"
					@mouseover="handleMouseover(index)"
					@mouseout="removeMouseover"
                />
                <circle
                    v-for="(color, index) in colors"
                    :v-model="selectedIndex"
                    :key="index"
                    :cx="circleX(index)"
                    :cy="circleY(index)"
                    :r="smallRadius"
                    :fill="color"
					:opacity="smallOpacities[index]"
                />
                <text
                    v-for="(color, index) in colors"
                    :key="index"
                    :x="textX(index)"
                    :y="textY(index)"
                    fill="white"
                    text-anchor="middle"
                    dominant-baseline="central"
                    font-size="30"
					style="font-weight: bold"
                >
                    {{ index + 1 }}
                </text>
                <text
					class="path"
                    v-for="(section, index) in sections"
                    :key="index"
                    :x="text2X(index)"
                    :y="text2Y(index)"
                    fill="white"
                    text-anchor="middle"
                    dominant-baseline="central"
					:style="{ fontSize: hoveredIndex === index ? '30px' : '20px', fontWeight: 'bold'}"
					v-on:click="handleClick(index)"
					@mouseover="handleMouseover(index)"
					@mouseout="removeMouseover"
                >
                    {{ section }}
                </text>
                <foreignObject
					class="path"
					v-for="(icon, index) in icons" 
					:key="index"
					:x="iconX(index)"
					:y="iconY(index)"
					width="50"
					height="50"
					:style="{ fontSize: hoveredIndex === index ? '25px' : '20px', fontWeight: 'bold'}"
					v-on:click="handleClick(index)"
					@mouseover="handleMouseover(index)"
					@mouseout="removeMouseover"
				>
					<i :class="icon" style="color: white;" ></i>
                </foreignObject>
				<path v-for="(color, index) in colors" :key="index"
					:d="'M ' + arrowStartPoint(index) + ' Q ' + circleX((index + 5) % 6) + ' ' + circleY((index + 5) % 6) + ' ' + arrowEndPoint(index)"
					stroke="white" stroke-width="8" fill="none" marker-start="url(#arrowhead)" 
				/>

                <circle class="centercircle" cx="350" cy="350" r="80" fill="white" />
				<image href="../assets/Logo_teal_stacked0.25x.png" x="300" y="300" width="100" height="100"/>
				<defs>
					<marker id="arrowhead" markerWidth="2" markerHeight="6" refX="1" refY="3" orient="auto">
						<polygon points="5 0, 0 3, 5 6" fill="white" />
					</marker>
				</defs>
            </svg>
			<v-dialog v-model="clickPolicy" max-width="25%">
				<v-card class="pb-5 pl-4 pr-4">
					<v-card-actions class="justify-end">
						<v-icon class="pl-1 pr-1" color="primary" @click="closeDialog()" style="border: 1px solid ;">fas fa-thin fa-times</v-icon>
					</v-card-actions>
					<v-card-action class="pa-5">
						<v-btn @click="moveToPolicy()" block color="#c6681c" style="color: white;">1. Update Policy Documents</v-btn>
					</v-card-action>
					<v-card-action>
						<v-btn @click="moveToRisk()" block color="#c6681c" style="color: white;">2. Update Risk Definition Table</v-btn>
					</v-card-action>
				</v-card>
			</v-dialog>
        </div>
		<div v-if="hoveredText" class="hoverContent" :style="{ top: hoveredText.y + 'px', left: hoveredText.x + 'px' }">{{ hoveredText.content }}</div>
    </div>
</template>
  
<script>
export default {
	data() {
		return {
			selectedIndex: 0,
			diameter: 700,
			smallRadius: 40,
			colors: [
				"#ea8a3d",
				"#c6681c",
				"#16a5a4",
				"#1a8588",
				"#70ac45",
				"#4e8326",
			],
			sections: ["POLICY", "RISK", "CHECK", "ACT", "VIEW", "REVIEW"],
			mouseOverText: [
				"Designing and updating the company's policy documents, such as the Code of Conduct.", 
				"Initial risk identification, get a full overview of risks in the supply chain in the Orixe platform.", 
				"Analyze the risks uncovered in 2. Describe and categorize risks and plot them into the risk matrix.", 
				"Create an action plan for the remediation of risks. Dispatch of follow-up revisions in the tool.", 
				"Analysis of the measures that have been implemented and update the risk matrix that was established in step 3.", 
				"Review of results from the mitigating actions, write a sum up, and generate the annual report in PDF."
			],
			hoveredText: "",
			icons: [
				"fas fa-rectangle-list",
				"fas fa-radiation",
				"fas fa-receipt",
				"fas fa-address-book",
				"fas fa-eye",
				"fas fa-users-gear"
			],
			/* iconWidth: 10,
			iconHeight: 50, */
			opacities: [1, 1, 1, 1, 1, 1],
			smallOpacities: [1, 1, 1, 1, 1, 1],
			showIcon: true,
			componentTop: 0,
			componentRight: 0,
			clickPolicy: false,
			hoveredIndex: null,
			/* imageSrc: "../assets/logorixe.jpg", */
		}
	},
	mounted() {
		this.componentTop = window.innerHeight / 2 - this.$el.offsetHeight / 2
		this.componentRight = window.innerWidth / 2 - this.$el.offsetWidth / 2
	},
	computed: {
		radius() {
			return this.diameter / 2 - this.smallRadius - 4
		},
	},
	methods: {
		closeDialog(){
			this.clickPolicy = false
			this.opacities = 1
			this.smallOpacities = 1
			window.location.reload()
		},
		moveToPolicy(){
			window.location.href = "/team/settings"
		},
		moveToRisk(){
			window.location.href = "/csr/riskmatrix/riskdefinition"
		},
		arrowStartPoint(index) {
			const start = this.circleX(index) + (this.smallRadius + 55) * Math.cos(this.arrowStartAngle(index))
			const startY = this.circleY(index) + (this.smallRadius + 55) * Math.sin(this.arrowStartAngle(index))
			return `${start},${startY}`
		},
		
		arrowEndPoint(index) {
			const startX = this.circleX(index) + (this.smallRadius - 60) * Math.cos(this.arrowStartAngle(index))
			const startY = this.circleY(index) + (this.smallRadius - 60) * Math.sin(this.arrowStartAngle(index))
			const endX = this.circleX((index + 5) % 6) - (this.smallRadius) * Math.cos(this.arrowEndAngle(index))
			const endY = this.circleY((index + 5) % 6) - (this.smallRadius) * Math.sin(this.arrowEndAngle(index))
		
			const controlX = startX + (endX - startX) * 0.4
			const controlY = startY + (endY - startY) * 0.4
			
			return `${controlX},${controlY} ${endX},${endY}`
		},

		arrowStartAngle(index) {
			return ((360 / 6) * (index - 10) + 58) * (Math.PI / 180)
		},
		
		arrowEndAngle(index) {
			return ((360 / 6) * ((index + 10) % 6 + 0.1) - 55) * (Math.PI / 180)
		},

		handleMouseover(index){
			this.opacities.fill(0.5)
			this.opacities[index] = 1,

			this.smallOpacities.fill(0.1)
			this.smallOpacities[index] = 1,
			(this.selectedIndex = index + 1)
			this.hoveredIndex = index
			this.$emit("selectedSection", this.selectedIndex)

			const center = this.diameter / 2
			const angle = (((360 / 6) * (index + 0.5) - 90) * Math.PI) / 180
			const offsetX = 300
			const offsetY = 42

			const textX = center + (this.radius - 100) * Math.cos(angle) + offsetX
			const textY = center + (this.radius - 100) * Math.sin(angle) + offsetY

			this.hoveredText = {
				content: this.mouseOverText[index],
				x: textX,
				y: textY
			}
		},
		removeMouseover(){
			this.opacities.fill(1)
			this.smallOpacities.fill(1)
			this.hoveredText = ""
			this.hoveredIndex = null
		},
		pie(index) {
			const center = this.diameter / 2
			const startAngle = (((360 / 6) * index - 90) * Math.PI) / 180
			const endAngle = (((360 / 6) * (index + 1) - 90) * Math.PI) / 180

			const x1 = center + this.radius * Math.cos(startAngle)
			const y1 = center + this.radius * Math.sin(startAngle)
			const x2 = center + this.radius * Math.cos(endAngle)
			const y2 = center + this.radius * Math.sin(endAngle)

			return `M ${center} ${center} L ${x1} ${y1} A ${this.radius} ${this.radius} 0 0 1 ${x2} ${y2} Z`
		},
		circleX(index) {
			const center = this.diameter / 2
			const angle = (((360 / 6) * (index + 0.5) - 90) * Math.PI) / 180
			return center + (this.radius) * Math.cos(angle)
		},
		circleY(index) {
			const center = this.diameter / 2
			const angle = (((360 / 6) * (index + 0.5) - 90) * Math.PI) / 180
			return center + (this.radius) * Math.sin(angle)
		},
		textX(index) {
			const center = this.diameter / 2
			const angle = (((360 / 6) * (index + 0.5) - 90) * Math.PI) / 180
			return center + (this.radius + 10) * Math.cos(angle)
		},
		textY(index) {
			const center = this.diameter / 2
			const angle = (((360 / 6) * (index + 0.5) - 90) * Math.PI) / 180
			return center + (this.radius + 10) * Math.sin(angle)
		},
		text2X(index) {
			const center = this.diameter / 2
			const angle = (((360 / 6) * (index + 0.5) - 90) * Math.PI) / 180
			return center + (this.radius - 100) * Math.cos(angle)
		},
		text2Y(index) {
			const center = this.diameter / 2
			const angle = (((360 / 6) * (index + 0.5) - 90) * Math.PI) / 180
			return center + (this.radius - 100) * Math.sin(angle)
		},
		iconX(index) {
			const center = this.diameter / 2
			const angle = (((360 / 6) * (index + 0.5) - 90) * Math.PI) / 180
			return (
				center - 15 + (this.radius - 100) * Math.cos(angle)
			)
		},
		iconY(index) {
			const center = this.diameter / 2
			const angle = (((360 / 6) * (index + 0.5) - 90) * Math.PI) / 180
			return (
				center - 45 + (this.radius - 100) * Math.sin(angle)
			)
		},
		handleClick(index) {
			/* (this.opacities[0] = 0.5),
			(this.opacities[1] = 0.5),
			(this.opacities[2] = 0.5),
			(this.opacities[3] = 0.5),
			(this.opacities[4] = 0.5),
			(this.opacities[5] = 0.5),
			(this.opacities[index] = 1),

			(this.smallOpacities[0] = 0.1),
			(this.smallOpacities[1] = 0.1),
			(this.smallOpacities[2] = 0.1),
			(this.smallOpacities[3] = 0.1),
			(this.smallOpacities[4] = 0.1),
			(this.smallOpacities[5] = 0.1),
			(this.smallOpacities[index] = 1),
			(this.selectedIndex = index + 1)
			this.$emit("selectedSection", this.selectedIndex) */

			const sectionUrls = [
				"",
				"/csr/esgscore",
				"/csr/riskmatrix/riskpage/#risk-matrix",
				"/csr/riskmatrix/riskpage/#action-plan",
				"/csr/riskmatrix/riskpage/#risk-description",
				"/csr/dashboard",
			]

			if( index === 0 ){
				this.clickPolicy = true
			}else{
				this.clickPolicy = false
				const sectionUrl = sectionUrls[index]
				window.location.href = sectionUrl
			}


			console.log(`Clicked on section "${index + 1}"`)
			console.log(this.opacities)
		},
	},
}
</script>
  
<style scoped>
    .circle {
        position: relative;
        display: flex;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
		justify-content: center;
        width: 100%;
        height: 100%;
    }
    .container {
        margin: 0;
        padding: 10px;
        align-items: center;

    }
	.path {
		cursor: pointer;
	}

	.hoverContent{
		position: absolute;
        transform: translateX(-50%);
        background-color: rgba(0, 0, 0, 0.7);
        color: white;
        padding: 5px 10px;
        border-radius: 5px;
		width: 300px;
	}
    /* .centercircle {
        background-image: (imageSrc);
    } */
</style>
  